import { OrderPaymentType } from "@sellar-io/api-v2/types";

export const mapToPaymentMethod = (
  type: OrderPaymentType | undefined,
  hasPaymentLink: boolean,
) => {
  switch (type) {
    case "checkout":
    case "cardPayment":
      return "Card payment";
    case "stripe":
      return "Card Payment Link";
    case "sellarCredit":
      return "Sellar Credit";
    case "cardPaymentWithDeposit":
      return "Card payment with deposit";
    case "manual":
    default:
      return hasPaymentLink ? "Card payment link" : "BACS manual invoice";
  }
};
